import get from 'lodash/get';


// For use with check controls only.  Looks at ikey property to restrict
// results to a particular check within a node.
const checkMixins = {
  computed: {
    errors() {
      if (!this.emitter.$store) {
        return [];
      }
      const errors = get(
        this.emitter.$store.getters['validation/errorsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      ).filter(
        error => error.metadata && error.metadata.checkKey === this.ikey,
      );
      return errors;
    },
    warnings() {
      if (!this.emitter.$store) {
        return [];
      }
      const warnings = get(
        this.emitter.$store.getters['validation/visibleWarningsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      ).filter(
        warning => warning.metadata && warning.metadata.checkKey === this.ikey,
      );
      return warnings;
    },
  }
};

export default checkMixins;